import { cloneDeep } from 'lodash'

import { Colors, Services } from '@sigma-frontend-libs/commons'

import { components, notificationsIcons } from '@/utils'

import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'
import panel from '@/components/services/settingsUser/notifications/events/panel'

function renderPanel(h, options, path) {
  if (this.settings) {
    return h(
      panel,
      {
        props: {
          path,
          value: cloneDeep(this.settings[path]),
          loading: options.loading.update[path],
          payload: options.payload,
          permission: options.keys[path],
          UserId: options.UserId,
          ResellerId: options.ResellerId
        },
        key: path,
        on: {
          input: event => {
            this.$emit('input', event, path)
          }
        }
      }
    )
  }
}
function renderPanels(h, options, group) {
  return this.schema.events[group].map(path => {
    return renderPanel.call(this, h, options, path)
  })
}
function renderGroupTitle(h, options, group) {
  return h(
    'div',
    {
      class: `${Services.settings}-${Services.notifications}-group__title`
    },
    [
      h(
        squircle,
        {
          props: {
            iconSVG: notificationsIcons[group],
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${options.serviceName}.subtitles.${options.path}.${group}`)
    ]
  )
}
function renderGroupHeader(h, options, group, expanded) {
  return h(
    'div',
    {
      class: `${Services.settings}-${Services.notifications}-group__header`
    },
    [
      renderGroupTitle.call(this, h, options, group),
      h(arrow, { props: { expanded } })
    ]
  )
}
function renderGroup(h, options, group) {
  return h(
    components['expansion-panel'],
    {
      scopedSlots: {
        header: ({ expanded }) => {
          return renderGroupHeader.call(this, h, options, group, expanded)
        }
      }
    },
    [ renderPanels.call(this, h, options, group) ]
  )
}
function renderGroups(h, options) {
  return Object.keys(this.schema.events).map(item => {
    return renderGroup.call(this, h, options, item)
  })
}
function renderBody(h, options) {
  return h(
    components['expansion-panels'],
    {
      props: {
        outline: true,
        rounded: true
      }
    },
    [ renderGroups.call(this, h, options) ]
  )
}

export default function(h, options) {
  return h(
    'div',
    {
      class: `${Services.settings}-${Services.notifications}`
    },
    [ renderBody.call(this, h, options) ]
  )
}
